let toolbar = /* html */ `
    <!--begin::Container-->
    <div id="kt_toolbar_container" class="container-fluid d-flex align-items-center">
        <!--begin::Page title-->
        <div class="flex-grow-1 flex-shrink-0 me-5">
            <!--begin::Page title-->
            <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                <!--begin::Title-->
                <!--<h1 class="d-flex align-items-center text-dark fw-bolder my-1 fs-3">Dashboard-->
                <i class="bi bi-people-fill"></i><small class="text-white fs-7 fw-bold my-1 ms-1">Online</small><span class="text-success">0</span>
                <!--begin::Separator-->
                <span class="h-20px border-gray-200 border-start ms-3 mx-2"></span>
                <!--end::Separator-->
                <!--begin::Description-->
                <i class="fas fa-swords"></i><small class="text-white fs-7 fw-bold my-1 ms-1">Matches Played</small><span class="text-warning">0</span>
                <!--end::Description--></h1>
                <!--end::Title-->
            </div>
            <!--end::Page title-->
        </div>
        <!--end::Page title-->
        <!--begin::Action group-->
        <div class="d-flex align-items-center flex-wrap">
            <!--begin::Wrapper-->
            <div class="flex-shrink-0 me-2">
                <ul class="nav">
                    <li class="nav-item">
                        <a class="nav-link btn btn-sm btn-color-muted btn-active-color-primary btn-active-light active fw-bold fs-7 px-4 me-1" data-bs-toggle="tab" href="#">Day</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link btn btn-sm btn-color-muted btn-active-color-primary btn-active-light fw-bold fs-7 px-4 me-1" data-bs-toggle="tab" href="">Week</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link btn btn-sm btn-color-muted btn-active-color-primary btn-active-light fw-bold fs-7 px-4" data-bs-toggle="tab" href="#">Year</a>
                    </li>
                </ul>
            </div>
            <!--end::Wrapper-->
            <!--begin::Wrapper-->
            <div class="d-flex align-items-center">
                <!--begin::Daterangepicker-->
                <a href="#" class="btn btn-sm btn-bg-light btn-color-gray-500 btn-active-color-primary me-2" id="kt_dashboard_daterangepicker" data-bs-toggle="tooltip" data-bs-dismiss="click" data-bs-trigger="hover" title="Select dashboard daterange">
                    <span class="fw-bold me-1" id="kt_dashboard_daterangepicker_title">Range:</span>
                    <span class="fw-bolder" id="kt_dashboard_daterangepicker_date">December 31</span>
                </a>
                <!--end::Daterangepicker-->
                <!--begin::Actions-->
                <div class="d-flex align-items-center">
                    <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light btn-active-color-primary" data-bs-toggle="modal" data-bs-target="#kt_modal_create_campaign">
                        <!--begin::Svg Icon | path: icons/duotune/files/fil005.svg-->
                        <span class="svg-icon svg-icon-2x">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path opacity="0.3" d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22ZM16 13.5L12.5 13V10C12.5 9.4 12.6 9.5 12 9.5C11.4 9.5 11.5 9.4 11.5 10L11 13L8 13.5C7.4 13.5 7 13.4 7 14C7 14.6 7.4 14.5 8 14.5H11V18C11 18.6 11.4 19 12 19C12.6 19 12.5 18.6 12.5 18V14.5L16 14C16.6 14 17 14.6 17 14C17 13.4 16.6 13.5 16 13.5Z" fill="black" />
                                <rect x="11" y="19" width="10" height="2" rx="1" transform="rotate(-90 11 19)" fill="black" />
                                <rect x="7" y="13" width="10" height="2" rx="1" fill="black" />
                                <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="black" />
                            </svg>
                        </span>
                        <!--end::Svg Icon-->
                    </button>
                </div>
                <!--end::Actions-->
            </div>
            <!--end::Wrapper-->
        </div>
        <!--end::Action group-->
    </div>
    <!--end::Container-->
`;

let live_header = `<div class="card-header">                                
<!--begin::Title-->
<div class="d-flex align-items-center">
    <div class="symbol symbol-50px me-4">
    <span class="symbol-label" style="background-color: #1b1b1b">
        <span class="svg-icon svg-icon-success svg-icon-2x"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.3" d="M4.05424 15.1982C8.34524 7.76818 13.5782 3.26318 20.9282 2.01418C21.0729 1.98837 21.2216 1.99789 21.3618 2.04193C21.502 2.08597 21.6294 2.16323 21.7333 2.26712C21.8372 2.37101 21.9144 2.49846 21.9585 2.63863C22.0025 2.7788 22.012 2.92754 21.9862 3.07218C20.7372 10.4222 16.2322 15.6552 8.80224 19.9462L4.05424 15.1982ZM3.81924 17.3372L2.63324 20.4482C2.58427 20.5765 2.5735 20.7163 2.6022 20.8507C2.63091 20.9851 2.69788 21.1082 2.79503 21.2054C2.89218 21.3025 3.01536 21.3695 3.14972 21.3982C3.28408 21.4269 3.42387 21.4161 3.55224 21.3672L6.66524 20.1802L3.81924 17.3372ZM16.5002 5.99818C16.2036 5.99818 15.9136 6.08615 15.6669 6.25097C15.4202 6.41579 15.228 6.65006 15.1144 6.92415C15.0009 7.19824 14.9712 7.49984 15.0291 7.79081C15.0869 8.08178 15.2298 8.34906 15.4396 8.55884C15.6494 8.76862 15.9166 8.91148 16.2076 8.96935C16.4986 9.02723 16.8002 8.99753 17.0743 8.884C17.3484 8.77046 17.5826 8.5782 17.7474 8.33153C17.9123 8.08486 18.0002 7.79485 18.0002 7.49818C18.0002 7.10035 17.8422 6.71882 17.5609 6.43752C17.2796 6.15621 16.8981 5.99818 16.5002 5.99818Z" fill="currentColor"/>
        <path d="M4.05423 15.1982L2.24723 13.3912C2.15505 13.299 2.08547 13.1867 2.04395 13.0632C2.00243 12.9396 1.9901 12.8081 2.00793 12.679C2.02575 12.5498 2.07325 12.4266 2.14669 12.3189C2.22013 12.2112 2.31752 12.1219 2.43123 12.0582L9.15323 8.28918C7.17353 10.3717 5.4607 12.6926 4.05423 15.1982ZM8.80023 19.9442L10.6072 21.7512C10.6994 21.8434 10.8117 21.9129 10.9352 21.9545C11.0588 21.996 11.1903 22.0083 11.3195 21.9905C11.4486 21.9727 11.5718 21.9252 11.6795 21.8517C11.7872 21.7783 11.8765 21.6809 11.9402 21.5672L15.7092 14.8442C13.6269 16.8245 11.3061 18.5377 8.80023 19.9442ZM7.04023 18.1832L12.5832 12.6402C12.7381 12.4759 12.8228 12.2577 12.8195 12.032C12.8161 11.8063 12.725 11.5907 12.5653 11.4311C12.4057 11.2714 12.1901 11.1803 11.9644 11.1769C11.7387 11.1736 11.5205 11.2583 11.3562 11.4132L5.81323 16.9562L7.04023 18.1832Z" fill="currentColor"/>
        </svg>
        </span>
    </span>
    </div>
    <h4 class="card-title align-items-start flex-column">
        <span class="card-label fw-bold text-gray-800" data-i18n="play.livematches">Live Matches</span>
        <span class="text-gray-400 mt-1 fw-semibold fs-6"></span>
    </h4>
</div>
<!--end::Title-->

<!--begin::Toolbar-->
<div class="card-toolbar">   
    
</div>
<!--end::Toolbar-->
</div>`;

let available_header = `<div class="card-header">                                
<!--begin::Title-->
<div class="d-flex align-items-center">
    <div class="symbol symbol-50px me-4">
    <span class="symbol-label" style="background-color: #1b1b1b">
        <span class="svg-icon svg-icon-info svg-icon-2x"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.3" d="M11.8 5.2L17.7 8.6V15.4L11.8 18.8L5.90001 15.4V8.6L11.8 5.2ZM11.8 2C11.5 2 11.2 2.1 11 2.2L3.8 6.4C3.3 6.7 3 7.3 3 7.9V16.2C3 16.8 3.3 17.4 3.8 17.7L11 21.9C11.3 22 11.5 22.1 11.8 22.1C12.1 22.1 12.4 22 12.6 21.9L19.8 17.7C20.3 17.4 20.6 16.8 20.6 16.2V7.9C20.6 7.3 20.3 6.7 19.8 6.4L12.6 2.2C12.4 2.1 12.1 2 11.8 2Z" fill="currentColor"/>
        <path d="M11.8 8.69995L8.90001 10.3V13.7L11.8 15.3L14.7 13.7V10.3L11.8 8.69995Z" fill="currentColor"/>
        </svg>
        </span>
    </span>
    </div>
    <h4 class="card-title align-items-start flex-column">
        <span class="card-label fw-bold text-gray-800" data-i18n="play.waitmatches">Available Servers</span>
        <span class="text-gray-400 mt-1 fw-semibold fs-6"></span>
    </h4>
</div>
<!--end::Title-->

<!--begin::Toolbar-->
<div class="card-toolbar">   
    
</div>
<!--end::Toolbar-->
</div>`;


let create = `<!--begin::Aside column-->
<div class="w-100 w-lg-300px mb-7 me-7 me-lg-10">
    <!--begin::Order details-->
    <div class="card card-flush py-4">
        <!--begin::Card header-->
        <div class="card-header">
            <div class="card-title">
                <h2 data-i18n="play.createLobby">Creating Lobby</h2>
            </div>
        </div>
        <!--end::Card header-->
        <!--begin::Card body-->
        <div class="card-body pt-0">
            <div class="d-flex flex-column gap-5">                                            
                <!--begin::Input group-->
                <div class="fv-row">
                    <!--begin::Label-->
                    <label class="required form-label" data-i18n="play.location">Location</label>
                    <!--end::Label-->
                    <style>
                        .select2-container--bootstrap5 .select2-selection--single .select2-selection__rendered{
                            width: 100%;
                        }
                    </style>
                    <!--begin::Select2-->
                    <select class="form-select mb-2" data-hide-search="true" data-placeholder="Select Location" name="payment_method" id="kt_ecommerce_edit_order_payment" data-i18n="[data-placeholder]play.selectLocation">
                        <option></option>                                                    
                        <option value="mi" data-location="mi" data-ping="82" data-kt-select2-country="assets/media/flags/us.gif">Miami</option>
                        <option value="ny" data-location="ny" data-ping="110" data-kt-select2-country="assets/media/flags/us.gif">New York</option>
                        <option value="la" data-location="la" data-ping="125" data-kt-select2-country="assets/media/flags/us.gif">Los Angeles</option>
                        <option value="ar" data-location="ar" data-ping="78" data-kt-select2-country="assets/media/flags/ar.gif">Buenos Aires</option>
                        <option value="br" data-location="br" data-ping="108" data-kt-select2-country="assets/media/flags/br.gif">Sao Paulo</option>
                    </select>
                    <!--end::Select2-->
                    <!--begin::Description-->
                    <!--<div class="text-muted fs-7">Set the date of the order to process.</div>-->
                    <!--end::Description-->
                </div>
                <!--end::Input group-->                                            

                <!--begin::Input group-->
                <div class="fv-row">
                    <!--begin::Label-->
                    <label class="required form-label" data-i18n="play.mode">Mode</label>
                    <!--end::Label-->
                    <!--begin::Radio group-->
                    <div class="btn-group w-100" data-kt-buttons="true" data-kt-buttons-target="[data-kt-button]">
                        
                        <!--begin::Radio-->
                        <label class="btn btn-outline-secondary text-muted text-hover-white text-active-white btn-outline btn-active-info" data-kt-button="true">
                            <!--begin::Input-->
                            <input class="btn-check" type="radio" name="method" value="1"/>
                            <!--end::Input-->
                            1vs1
                        </label>
                        <!--end::Radio-->

                        <!--begin::Radio-->
                        <label class="btn btn-outline-secondary text-muted text-hover-white text-active-white btn-outline btn-active-info" data-kt-button="true">
                            <!--begin::Input-->
                            <input class="btn-check" type="radio" name="method" value="2" />
                            <!--end::Input-->
                            2vs2
                        </label>
                        <!--end::Radio-->

                        <!--begin::Radio-->
                        <label class="btn btn-outline-secondary text-muted text-hover-white text-active-white btn-outline btn-active-info active" data-kt-button="true">
                            <!--begin::Input-->
                            <input class="btn-check" type="radio" name="method"  checked="checked" value="5"  />
                            <!--end::Input-->
                            5vs5
                        </label>
                        <!--end::Radio-->
                    </div>
                    <!--end::Radio group-->
                </div>
                <!--end::Input group-->

                <!--begin::Input group-->
                <div class="fv-row">
                    <!--begin::Label-->
                    <label class="required form-label" data-i18n="play.title">Title</label>
                    <!--end::Label-->
                    <!--begin::Editor-->
                    <input id="kt_ecommerce_edit_order_date" name="order_date" placeholder="Select a title" class="form-control mb-2" value="" autocomplete="off" data-i18n="[placeholder]play.insertTitle"/>
                    <!--end::Editor-->
                    <!--begin::Description-->
                    <div class="text-muted fs-7" data-i18n="play.labelTitle">Set the title of the lobby.</div>
                    <!--end::Description-->
                </div>
                <!--end::Input group-->

                <!--begin::Input group-->
                <div class="fv-row">
                    <div class="d-flex flex-stack">
                        <!--begin::Label-->
                        <div class="me-5">
                            <!--begin::Label-->
                            <label class="form-label" data-i18n="play.anticheat">Anticheat</label>
                            <!--end::Label-->
                            <!--begin::Input-->
                            <div class="fs-7 fw-bold text-muted" data-i18n="play.labelAnticheat">Highly recommened, let's make a cheaters-free community</div>
                            <!--end::Input-->
                        </div>
                        <!--end::Label-->
                        <!--begin::Switch-->
                        <label class="form-check form-switch form-check-custom form-check-solid">
                            <!--begin::Input-->
                            <input class="form-check-input h-20px w-30px" name="billing" type="checkbox" value="1" id="kt_modal_update_customer_billing" checked="checked">
                            <!--end::Input-->
                            <!--begin::Label-->
                            <span class="form-check-label fw-bold text-muted" for="kt_modal_update_customer_billing" data-i18n="play.yes">Yes</span>
                            <!--end::Label-->
                        </label>
                        <!--end::Switch-->
                    </div>
                </div>
                <!--end::Input group-->
                
                <button type="button" class="btn btn-outline btn-outline-primary fw-bolder w-100" id="kt_invoice_submit_button" data-i18n="play.create">
                    Create a Lobby</button>
                
            </div>
        </div>
        <!--end::Card header-->
    </div>
    <!--end::Order details-->
</div>
<!--end::Aside column-->`;


const view = /*html*/`

    
    <div id="kt_content_container" class="container-xxl">
        <style>
            .map-dark-bg::after {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: -1;
                background-image: linear-gradient(180deg, rgba(21, 21, 21, 0.65) 100%, #1f1f1f 100%);
                content: "";
            }
            .slider-container {
                max-width: 100vw;
                width: 100%;
                overflow: hidden;
                min-width: 0;
            }
            .slick-arrow {
                position: absolute;
                top: 50%;
                -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
                cursor: pointer
            }

            .slick-prev {
                left: -30px;                
            }

            .slick-next {
                right: -30px
            }

            .slider-container .slick-prev, .slider-container .slick-next {
                visibility: hidden;
                opacity: 0;
                transition: opacity 0.3s ease 0s, visibility 0.3s ease 0s;
            }

            .slider-container:hover .slick-prev, .slider-container:hover .slick-next {
                visibility: visible;
                opacity: 0.75;
            }

            .bg {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                z-index: 1;
                height: 100%;
                transition: opacity .3s ease;
                background: linear-gradient(0deg,rgba(21,21,21,.25),rgba(21,21,21,.25));
            }

            .bg-2 {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                z-index: 1;
                height: 100%;
                transition: opacity .3s ease;
                background: linear-gradient(0deg,rgba(21,21,21,.65),rgba(21,21,21,.65));
            }

            .card:hover .bg {
                opacity: 0;
            }            
            
            .location-select-dropdown {
                max-width: "250px !important";
            }

            .server-card {
                position: relative;
                display: flex;
                flex-direction: column;
                min-width: 0;
                word-wrap: break-word;
                background-color: #1F1F1F;
                background-clip: border-box;
                border: 1px solid #2B2B2b;
                border-radius: 0.475rem;
                box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);
            }
            .server-card:hover .bg-2 {
                opacity: 0;
            }
            
        </style>

        
        <div class="d-flex slider slider-container h-85px mh-85px align-items-center mb-4">
            <a href="https://discord.gg/9u4mHsf3dD" target="_blank" class="text-gray-800 text-hover-white text-active-white">
            <div class="card card-flush bg-transparent border w-250px h-80px me-3">
                <div class="d-inline-block w-100 h-100 rounded overflow-hidden">
                    <div class="position-relative h-100 px-6 bgi-position-x-end bgi-position-y-center bgi-size-cover" style="background-image:url('assets/media/misc/discord_dark.png')">
                        <div class="bg"></div>
                        <div class="d-flex h-100 align-items-center">
                            <span class="position-relative z-index-2 fs-6 lh-1 bg-light bg-opacity-50" style="padding: 0.5em 0.85em;white-space: nowrap;vertical-align: baseline;border-radius: 0.475rem;">Join to our<br/>Discord Server</span>
                        </div>
                        
                    </div>
                </div>                    
            </div>
            </a>

            <a href="ts3server://ts.pdxplay.org" class="external-handler text-gray-800 text-hover-white text-active-white">
            <div class="card card-flush bg-transparent border w-250px h-80px me-3">
                <div class="d-inline-block w-100 h-100 rounded overflow-hidden">
                    <div class="position-relative h-100 px-6 bgi-position-x-end bgi-position-y-center bgi-size-cover" style="background-image:url('assets/media/misc/ts_dark.png')">
                        <div class="bg"></div>
                        <div class="d-flex h-100 align-items-center">                            
                            <span class="position-relative z-index-2 fs-6 lh-1 bg-light bg-opacity-50" style="padding: 0.5em 0.85em;white-space: nowrap;vertical-align: baseline;border-radius: 0.475rem;">Join to our<br/>TeamSpeak 3</span>
                        </div>
                    </div>
                </div>                    
            </div>
            </a>

            <div class="card card-flush bg-transparent border w-250px h-80px me-3 text-gray-800 text-hover-white text-active-white cursor-pointer">
                <div class="d-inline-block w-100 h-100 rounded overflow-hidden">
                    <div class="position-relative h-100 px-6 bgi-position-x-end bgi-position-y-center bgi-size-cover" style="background-image:url('assets/media/misc/frag.png')">
                        <div class="bg"></div>
                        <div class="d-flex h-100 align-items-center justify-content-center">                            
                            <span class="position-relative z-index-2 fs-6 lh-1 bg-light bg-opacity-50 text-center" style="padding: 0.5em 0.85em;white-space: nowrap;vertical-align: baseline;border-radius: 0.475rem;">How to play<br/>Ranked Matches?</span>
                        </div>
                    </div>
                </div>                    
            </div>
            
        </div>
            
        
        <div class="d-flex flex-row">

            <!--<div class="flex-row-auto w-100 w-275px me-6">
                <div class="card card-flush">           
                    <div class="card-body p-6">
                        <ul class="nav nav-tabs nav-pills flex-row border-0 flex-md-column fs-6" role="tablist">
                            <li class="nav-item w-100 me-0 mb-md-2" role="presentation" style="cursor:not-allowed">
                                <span class="play-training-tab w-100 btn btn-flex btn-color-muted btn-active-light btn-active-color-white p-4 disabled" data-bs-toggle="tab" data-bs-target="#play-tab-training" aria-selected="true" role="tab" tab="training">
                                    <i class="fad fa-swords fs-2x pe-0 me-3"></i>
                                    <span class="d-flex flex-column align-items-start">
                                        <span class="fs-5 fw-bold text-white" data-i18n="">Ranked Matchmaking</span>
                                        <span class="fs-8 fw-bold text-gray-700 text-start" data-i18n="">Real competition</span>
                                    </span>
                                </span>
                            </li>
                            <li class="nav-item w-100 me-0 mb-md-2" role="presentation">
                                <span class="play-pug-tab w-100 btn btn-flex btn-color-muted btn-active-light btn-active-color-white p-4 active" data-bs-toggle="tab" data-bs-target="#play-tab-pug" aria-selected="true" role="tab" tab="pug">
                                    <i class="fad fa-sword fs-2x pe-0 me-3"></i>
                                    <span class="d-flex flex-column align-items-start">
                                        <span class="fs-5 fw-bold text-white" data-i18n="">Play PUG</span>
                                        <span class="fs-8 fw-bold text-gray-700 text-start" data-i18n="">Old gather system</span>
                                    </span>
                                </span>
                            </li>
                            <li class="nav-item w-100 me-0 mb-md-2" role="presentation" style="cursor:not-allowed">
                                <span class="play-training-tab w-100 btn btn-flex btn-color-muted btn-active-light btn-active-color-white p-4 disabled" data-bs-toggle="tab" data-bs-target="#play-tab-training" aria-selected="true" role="tab" tab="training">
                                    <i class="fad fa-crosshairs fs-2x pe-0 me-3"></i>
                                    <span class="d-flex flex-column align-items-start">
                                        <span class="fs-5 fw-bold text-white" data-i18n="">Training Servers</span>
                                        <span class="fs-8 fw-bold text-gray-700 text-start" data-i18n="">Everything you need</span>
                                    </span>
                                </span>
                            </li>

                            <li class="nav-item w-100 me-0 mb-md-2" role="presentation" style="cursor:not-allowed">
                                <span class="play-training-tab w-100 btn btn-flex btn-color-muted btn-active-light btn-active-color-white p-4 disabled" data-bs-toggle="tab" data-bs-target="#play-tab-training" aria-selected="true" role="tab" tab="training">
                                    <i class="fad fa-burn fs-2x pe-0 me-3"></i>
                                    <span class="d-flex flex-column align-items-start">
                                        <span class="fs-5 fw-bold text-white" data-i18n="">Custom Match</span>
                                        <span class="fs-8 fw-bold text-gray-700 text-start" data-i18n="">Create a private game</span>
                                    </span>
                                </span>
                            </li>

                            
                           
                        </ul>
                        <div class="separator my-2"></div>
                        
                    </div>
                </div>
            </div>-->

            <div class="flex-row-fluid">
                <div class="d-flex justify-content-between">
                    <ul class="nav nav-pills nav-pills-custom flex-nowrap hover-scroll-x mb-0" id="loc-list">
                        
                    </ul>            
                </div>
                <div class="">
                    
                    <!--begin::Form-->
                    <div class="d-flex flex-column flex-lg-row">
                        <!--begin::Main column-->
                        <div class="d-flex flex-column flex-lg-row-fluid gap-7 gap-lg-10">
                            <div class="card card-flush">
                                <div class="card-header px-6 py-4">
                                    <div class="btn-group" data-kt-buttons="true" data-kt-buttons-target="[data-kt-button]">
                                        <!--begin::Radio-->
                                        <label class="btn btn-icon btn-active-primary btn-outline btn-outline-secondary btn-color-muted btn-active-color-gray-200 active" data-kt-button="true">
                                            <!--begin::Input-->
                                            <input class="btn-check" type="radio" name="grid" checked="checked" value="1">
                                            <!--end::Input-->
                                            <i class="fa fa-list fs-4"></i>
                                        </label>
                                        <!--end::Radio-->
                        
                                        <!--begin::Radio-->
                                        <label class="btn btn-icon btn-active-primary btn-outline btn-outline-secondary btn-color-muted btn-active-color-gray-200" data-kt-button="true">
                                            <!--begin::Input-->
                                            <input class="btn-check" type="radio" name="grid" value="2">
                                            <!--end::Input-->
                                            <i class="fa fa-th fs-4"></i>
                                        </label>
                                        <!--end::Radio-->                    
                                    </div>
                                    <div class="min-w-250px">
                                        <select class="form-select form-select-solid location-select"  multiple="multiple">
                                        </select>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="lobby-list">
                                <div id="lobby-list-empty" class="text-center d-none">
                                    <!--begin::Icon-->
                                    <div class="pt-10 pb-10">                                
                                        <span class="svg-icon svg-icon-4x svg-icon-primary opacity-50">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.3" d="M4.05424 15.1982C8.34524 7.76818 13.5782 3.26318 20.9282 2.01418C21.0729 1.98837 21.2216 1.99789 21.3618 2.04193C21.502 2.08597 21.6294 2.16323 21.7333 2.26712C21.8372 2.37101 21.9144 2.49846 21.9585 2.63863C22.0025 2.7788 22.012 2.92754 21.9862 3.07218C20.7372 10.4222 16.2322 15.6552 8.80224 19.9462L4.05424 15.1982ZM3.81924 17.3372L2.63324 20.4482C2.58427 20.5765 2.5735 20.7163 2.6022 20.8507C2.63091 20.9851 2.69788 21.1082 2.79503 21.2054C2.89218 21.3025 3.01536 21.3695 3.14972 21.3982C3.28408 21.4269 3.42387 21.4161 3.55224 21.3672L6.66524 20.1802L3.81924 17.3372ZM16.5002 5.99818C16.2036 5.99818 15.9136 6.08615 15.6669 6.25097C15.4202 6.41579 15.228 6.65006 15.1144 6.92415C15.0009 7.19824 14.9712 7.49984 15.0291 7.79081C15.0869 8.08178 15.2298 8.34906 15.4396 8.55884C15.6494 8.76862 15.9166 8.91148 16.2076 8.96935C16.4986 9.02723 16.8002 8.99753 17.0743 8.884C17.3484 8.77046 17.5826 8.5782 17.7474 8.33153C17.9123 8.08486 18.0002 7.79485 18.0002 7.49818C18.0002 7.10035 17.8422 6.71882 17.5609 6.43752C17.2796 6.15621 16.8981 5.99818 16.5002 5.99818Z" fill="currentColor"/>
                                            <path d="M4.05423 15.1982L2.24723 13.3912C2.15505 13.299 2.08547 13.1867 2.04395 13.0632C2.00243 12.9396 1.9901 12.8081 2.00793 12.679C2.02575 12.5498 2.07325 12.4266 2.14669 12.3189C2.22013 12.2112 2.31752 12.1219 2.43123 12.0582L9.15323 8.28918C7.17353 10.3717 5.4607 12.6926 4.05423 15.1982ZM8.80023 19.9442L10.6072 21.7512C10.6994 21.8434 10.8117 21.9129 10.9352 21.9545C11.0588 21.996 11.1903 22.0083 11.3195 21.9905C11.4486 21.9727 11.5718 21.9252 11.6795 21.8517C11.7872 21.7783 11.8765 21.6809 11.9402 21.5672L15.7092 14.8442C13.6269 16.8245 11.3061 18.5377 8.80023 19.9442ZM7.04023 18.1832L12.5832 12.6402C12.7381 12.4759 12.8228 12.2577 12.8195 12.032C12.8161 11.8063 12.725 11.5907 12.5653 11.4311C12.4057 11.2714 12.1901 11.1803 11.9644 11.1769C11.7387 11.1736 11.5205 11.2583 11.3562 11.4132L5.81323 16.9562L7.04023 18.1832Z" fill="currentColor"/>
                                            </svg>
                                        </span>
                                        <!--end::Svg Icon-->                                
                                    </div>
                                    <!--end::Icon-->
                                    <!--begin::Message-->
                                    <div class="pb-15 fw-semibold">
                                        <h3 class="text-gray-600 fs-5 mb-2" data-i18n="play.no_sv_found">No servers found</h3>
                                        <div class="text-muted fs-7" data-i18n="play.sorry">Sorry for the inconvenience, refresh the app please.</div>
                                    </div>
                                    <!--end::Message-->
                                </div>

                                <div id="lobby-list-loader" class="text-center">
                                    <div class="d-flex justify-content-center pt-10 pb-10">
                                        <div class="spinner-border text-primary text-center" role="status" style="width: 3rem; height: 3rem;">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>                                                       
                                    </div>
                                    <div class="pb-15 fw-semibold">
                                        <h3 class="text-gray-600 fs-5 mb-2" data-i18n="play.lookavailable">Looking for available Servers</h3>                                
                                    </div>
                                </div>

                                <div id="lobby-cont-live" class="card card-flush card-px-0 d-none bg-transparent">
                                    
                                    <div class="card-body py-1">
                                        <div id="lobby-list-live" class="">
                                        
                                        </div>
                                    </div>
                                </div>
                                
                                

                                <div id="lobby-cont-wait" class="card d-none card-flush card-px-0 bg-transparent">
                                    
                                    <div class="card-body py-1">
                                        <div id="lobby-list-wait" class="">
                                        
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <!--end::Main column-->
                    </div>
                    <!--end::Form-->

                    
                </div>
            </div>

        </div> 

    </div>


`;


export default view;